/*
 * @Author: wankong
 * @Date: 2021-09-04 15:38:24
 * @LastEditTime: 2021-11-03 18:33:22
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './common/common.css'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// use

Vue.use(Element)

import './common/axios.setting.js'

import './common/filter.js'




Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')